// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.badge-outline-danger {\r\n  color: #f1536e;\r\n  border: 1px solid #f1536e;\n}\r\n", ""]);
// Exports
module.exports = exports;
